export function removeItem(items, itemToRemoveId) {
    let itemsReturn = [];
    items.forEach(item => {
        if (item.id !== itemToRemoveId) {
            itemsReturn.push(item);
        }
    });
    return itemsReturn;
}



// WEBPACK FOOTER //
// ./src/js/reducers/common/remove-item.js